
import EtcForm from "../screens/etc/view-etc";
import MainHomePage from "../screens/home/home";
import InventoryUpdate from "../screens/material-ledger/request-ml/inventory-updates";
import MaterialLedgerDashboards from "../screens/material-ledger/request-ml/material-ledger-summary";
import RawMaterialDeclaration from "../screens/material-ledger/request-ml/ml-dashboard/raw-material-declaration-form";
import RawMaterialSummarry from "../screens/material-ledger/request-ml/raw-material-summary";
import RmdfForm from "../screens/material-ledger/request-ml/rmdf-details";
import ScForm from "../screens/scope-certificates/request-sc";
import SuppliersDashboard from "../screens/scope-certificates/request-sc/sc-dashboard/suppliers-dasboard";
import TCSuppliersDashboard from "../screens/suppliers/dashboard/cb-landingpage";
import TcForm from "../screens/transaction-certificates/request-tc";
import CBdashboard from "../screens/transaction-certificates/tc-dashboard/cb-landingpage";
import CBdashboardV4 from "../screens/v4/transaction-certificates/tc-dashboard/cb-landingpage";
import ScV4Form from "../screens/v4/scope-certificates/request-sc";
import SuppliersDashboardV4 from "../screens/v4/scope-certificates/request-sc/sc-dashboard/suppliers-dasboard";
import TcV4Form from "../screens/transaction-certificates/request-tc";
import atcForm from '../screens/alternative-transaction-certificates/request-atc/index';
import ATCLandingPage from "../screens/alternative-transaction-certificates/atc-dashboard/cb-landingpage";
import AdminDashboard from "../screens/admin/admin-dashboard";
import MLQueryReport from "../screens/material-ledger/request-ml/ml-insighthub-report/index";

export interface Route {
    id: number;
    path: string;
    component: any;
    access?: string | string[];
    requiresAdmin?: boolean; // Flag to indicate if route requires admin access
}

export const publicRoute: Route[] = [
    {
        id: 1,
        path:  '/tc-dashboard',
        component: CBdashboard
    },
    {
        id: 2,
        path: '/tc/:formtype/:currentTab',
        component: TcForm
    },
    {
        id: 3,
        path: '/tc/:formtype/:currentTab/:TE_ID',
        component: TcForm
    },
    {
        id: 4,
        path: '/sc-dashboard',
        component: SuppliersDashboard
    },
    {
        id: 5,
        path: '/sc/:formtype/:currentTab',
        component: ScForm
    },
    {
        id: 6,
        path: '/sc/:formtype/:currentTab/:SC_ID',
        component: ScForm
    },

    {
        id: 7,
        path: '/etc/:formtype/:currentTab/:etcId',
        component: EtcForm
    },
    {
        id: 7,
        path: '/ml-form',
        component: RawMaterialSummarry,
    }, 
    {
        id: 8,
        path: '/ml/material-ledger',
        component: MaterialLedgerDashboards
    },
    {
        id: 9,
        path: '/ml/inventory-updates',
        component: InventoryUpdate
    },
    {
        id: 8,
        path: '/ml/material-ledger/:TE_ID/:RM_CODE',
        component: MaterialLedgerDashboards
    },
    {
        id: 9,
        path: '/ml/inventory-updates/:TE_ID/:RM_CODE',
        component: InventoryUpdate
    },
    {
        id: 10,
        path: '/ml-dec_form',
        component: RawMaterialDeclaration
    },
    {
        id: 11,
        path: '/ml-form/rmdf/mdf',
        component: RmdfForm
    },
    {
        id: 12,
        path: '/home',
        component: MainHomePage
    },
    {
        id: 13,
        path: '/suppliers',
        component: TCSuppliersDashboard
    },
    {
        id: 15,
        path: '/atc',
        component: ATCLandingPage
    },
    {
        id: 16,
        path: '/create-atc',
        component: atcForm
    },
    { 
        id: 17, 
        path: '/admin', 
        component: AdminDashboard, 
        requiresAdmin: true 
    },
    {   id: 28,
        path: '/ml-report', 
        component: MLQueryReport 
    },
    //v4
     {
        id: 14,
        path:  '/v4/tc-dashboard',
        component: CBdashboardV4
    },
    {
        id: 2,
        path: '/v4/tc/:formtype/:currentTab',
        component: TcV4Form
    },
    {
        id: 3,
        path: '/v4/tc/:formtype/:currentTab/:TE_ID',
        component: TcV4Form
    },
    {
        id: 4,
        path: '/v4/sc-dashboard',
        component: SuppliersDashboardV4
    },
    {
        id: 5,
        path: '/v4/sc/:formtype/:currentTab/:SC_ID',
        component: ScV4Form
    },
    {
        id: 6,
        path: '/v4/sc/:formtype/:currentTab',
        component: ScV4Form
    },
    
];
